import { useEffect } from "react";

const LogOut = () => {
  useEffect(() => {
    window.location.href = `${window.location.protocol}//${window.location.host}/login`;
  }, []);
  return <></>;
};

export default LogOut;
